/**
 * @desc: - 彩票页错误信息，比如未到销售时间等
 * @param  {[STRING]} text:        [提示语]
 * @author: ammo
 */
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

export default class LotteryError extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ReactCSSTransitionGroup 
        transitionAppear={true}
        transitionEnterTimeout={300} 
        transitionLeaveTimeout={300} 
        transitionAppearTimeout ={300} 
        transitionName='fade'>
        <div className="container-main lotteryBox" key={this.props.params.lotteryFlag}>
          <div id="subContent" className="bet_right">
              <div className="no-open_award">{this.props.text}</div>
            </div>
        </div>
      </ReactCSSTransitionGroup>
    );
  }
}
